import store from '../store'

const LogsPlugin = {}
LogsPlugin.install = function (Vue) {
  const logEvent = (data) => {
    return store.dispatch('logs/logEvent', data)
  }

  const logInfo = (data) => {
    return store.dispatch('logs/logEvent', { ...data, level: 'Info' })
  }

  const logError = (data) => {
    return store.dispatch('logs/logEvent', { ...data, level: 'Error' })
  }

  const logException = (data) => {
    return store.dispatch('logs/logEvent', { ...data, level: 'Exception' })
  }

  Vue.prototype.$logInfo = logInfo
  Vue.prototype.$logEvent = logEvent
  Vue.prototype.$logError = logError
  Vue.prototype.$logException = logException
}

export default LogsPlugin
